<label [for]="provider.npi" class="form-check-label">
  <div class="small name">
    <strong>
      {{ provider.name | blankValueDash }}
      @if (showFaxStatus) {
        <span>
          ({{ provider.relevantProviderOffice?.status | providerOfficeFaxStatus }})
        </span>
      }
    </strong>
    @if (provider.npi) {
      <a target="_blank" href="/capture-admin/providers/{{ provider.npi }}">
        <fa-icon [icon]="['fas', 'external-link-alt']" size="sm" />
      </a>
    }
    <app-copy-to-clipboard [text]="provider.name" />
  </div>
  <div class="small">{{ provider.specialty | blankValueDash }}</div>
  <div class="small">
    <strong>NPI:</strong>
    <a target="_blank" href="/capture-admin/providers/{{provider.npi}}">
      {{ provider.npi }}
    </a>
    <app-copy-to-clipboard [text]="provider.npi" />
  </div>

  @if (provider.relevantProviderOffice) {
    <app-provider-office-association-notes
      [providerOffice]="provider.relevantProviderOffice"
      [enablePopover]="true"
      />
  }
</label>
